/**
 * Production-safe logger.
 * Strips console output in production builds to reduce overhead in the
 * Capacitor WebView and avoid leaking debug data.
 */
const isProd = process.env.NODE_ENV === 'production';

const noop = () => {};

export const logger = {
  log: isProd ? noop : console.log.bind(console),
  info: isProd ? noop : console.info.bind(console),
  debug: isProd ? noop : console.debug.bind(console),
  warn: console.warn.bind(console),
  error: console.error.bind(console),
};

export default logger;
